'use strict';

var backToTop = {

	visible: false,
	offset: 100,

	init: function () {
		var el = document.getElementById('back-to-top');

		if (el === undefined || el === null) return;

		// init: show/hide
		backToTop.validateScroll(el);

		// scroll: show/hide
		window.addEventListener('scroll', function () {
			backToTop.validateScroll(el);
		});

		// transition start: zIndex
		el.addEventListener('transitionstart', function () {
			if (backToTop.visible) {
				el.classList.add('z-50');
				el.classList.remove('-z-10');
			}
		});

		// transition end: zIndex
		el.addEventListener('transitionend', function() {
			if (!backToTop.visible) {
				el.classList.remove('z-50');
				el.classList.add('-z-10');
			}
		});
	},

	validateScroll: function (el) {
		if (backToTop.visible && window.scrollY < backToTop.offset) {
			backToTop.toggleVisibility(el, false);
		}
		else if (!backToTop.visible && window.scrollY >= backToTop.offset) {
			backToTop.toggleVisibility(el, true);
		}
	},

	toggleVisibility: function (el, show) {
		var linkEl = el.querySelector('a');
		if (show) {
			backToTop.visible = true;
			linkEl.setAttribute('tabindex', '0');
			el.classList.remove('hidden');
			el.classList.add('flex');
			setTimeout(function () {
				el.classList.remove('opacity-0');
				el.classList.add('opacity-100');
			});
		} else {
			backToTop.visible = false;
			linkEl.setAttribute('tabindex', '-1');
			el.classList.remove('opacity-100');
			el.classList.add('opacity-0');
			setTimeout(function () {
				el.classList.remove('flex');
				el.classList.add('hidden');
			});
		}
	}
};

window.addEventListener('load', backToTop.init());